import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
  Legend,
} from "chart.js";
import "chartjs-adapter-moment";
import { format } from "date-fns";
import React from "react";
import { Box } from "@material-ui/core";

ChartJS.register(
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
  Legend
);

const COLORS = [
  "#0072B2", // Blue
  "#D55E00", // Vermillion
  "#009E73", // Teal green
  "#CC79A7", // Reddish purple
  "#F0E442", // Yellow
  "#56B4E9", // Sky blue
  "#E69F00", // Orange
  "#000000", // Black
];

const annotatedLinePlugin = {
  id: "annotatedVerticalLine",
  afterDraw(chart) {
    const active = chart.tooltip?.getActiveElements?.();
    if (!active?.length) return;
    const x = active[0].element.x;
    const yScale = Object.values(chart.scales).find((s) => s.axis === "y");
    if (!yScale) return;
    const ctx = chart.ctx;

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(x, yScale.top);
    ctx.lineTo(x, yScale.bottom);
    ctx.lineWidth = 9;
    ctx.strokeStyle = "rgba(0, 0, 255, 0.2)";
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(x, yScale.top);
    ctx.lineTo(x, yScale.bottom);
    ctx.lineWidth = 1;
    ctx.strokeStyle = "rgba(0, 0, 255, 0.4)";
    ctx.stroke();
    ctx.restore();
  },
};

export default function StreamflowChart({
  seriesByLoc,
  unit,
  parameter,
  height = 450,
}) {
  const data = {
    datasets: Object.entries(seriesByLoc).map(([locName, pts], i) => ({
      label: locName,
      data: pts.map((d) => ({ x: d.date, y: d.value })),
      borderColor: COLORS[i % COLORS.length],
      backgroundColor: COLORS[i % COLORS.length],
      pointRadius: 0,
      borderWidth: 1.5,
      tension: 0,
      fill: false,
      spanGaps: false,
    })),
  };

  const options = {
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      axis: "x",
      intersect: false,
    },
    plugins: {
      tooltip: {
        mode: "index",
        axis: "x",
        intersect: false,
        filter: (ti) => ti.raw.y != null,
        callbacks: {
          title: (items) => {
            if (!items.length) return "";
            const date = items[0].raw.x;
            return format(date, "MMM dd, yyyy");
          },
          label: (ti) => {
            return `${ti.dataset.label}: ${Number(ti.raw.y).toFixed(
              1
            )} ${unit}`;
          },
        },
        backgroundColor: "#fff",
        titleColor: "#333",
        bodyColor: "#333",
        borderColor: "#999",
        borderWidth: 1,
        cornerRadius: 6,
        padding: 10,
        titleFont: { weight: "bold", size: 14 },
        bodyFont: { size: 14 },
      },
      legend: {
        position: "top",
      },
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: "month",
          displayFormats: {
            month: "MM/YY",
          },
        },
        ticks: {
          autoSkip: true,
        },
      },
      y: {
        title: {
          display: true,
          text: `${parameter} (${unit})`,
        },
      },
    },
  };

  return (
    <Box height={height} width="100%">
      <Line data={data} options={options} plugins={[annotatedLinePlugin]} />
    </Box>
  );
}
